"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfile = void 0;
const formik_1 = require("formik");
const react_1 = __importStar(require("react"));
const Yup = __importStar(require("yup"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_ui_1 = require("@sierralabs/core-ui");
const react_material_ui_formik_1 = require("@sierralabs/react-material-ui-formik");
const useUpdateUser_1 = require("./hooks/useUpdateUser");
const UserContext_1 = require("./UserContext");
const StyledDiv = styled_components_1.default.div `
  height: 100%;
  flex: 1;
`;
const passwordMinLength = 8;
const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;
const passwordRegexErrorMessage = 'Need at least an uppercase and a lowercase letter, and a number.';
const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('Please enter your given name.'),
    lastName: Yup.string().required('Please enter your family name.'),
    email: Yup.string().required('Email is required.'),
    password: Yup.string()
        .matches(passwordRegex, passwordRegexErrorMessage)
        .min(passwordMinLength, `Minimum ${passwordMinLength} characters.`),
    passwordConfirmation: Yup.string().oneOf([Yup.ref('password'), ''], 'Passwords must match.')
});
const UserProfile = () => {
    const formikRef = (0, react_1.useRef)();
    const { user } = (0, UserContext_1.useUserContext)();
    const userId = user && user.id ? user.id : 0;
    const [onSuccess, setOnSuccess] = (0, react_1.useState)(false);
    const { updatedUser, error, updateUser } = (0, useUpdateUser_1.useUpdateUser)(userId);
    (0, react_1.useEffect)(() => {
        if (updatedUser) {
            setOnSuccess(true);
        }
        if (formikRef && formikRef.current) {
            formikRef.current.setSubmitting(false);
        }
    }, [updatedUser, error]);
    const handleSubmit = (form) => {
        if (user) {
            user.firstName = form.firstName;
            user.lastName = form.lastName;
            user.email = form.email;
            if (form.password) {
                user.password = form.password;
            }
            updateUser(user);
        }
    };
    return (react_1.default.createElement(core_ui_1.PageTemplate, null,
        react_1.default.createElement(core_ui_1.PageTemplateHeader, null,
            react_1.default.createElement("h2", null, "My Profile")),
        react_1.default.createElement(core_ui_1.PageTemplateCardOver, null,
            react_1.default.createElement(core_ui_1.CardTitle, null, "User Info"),
            react_1.default.createElement(core_ui_1.CardContent, { padding: 'large' }, user && (react_1.default.createElement(formik_1.Formik, { innerRef: (formik) => (formikRef.current = formik), initialValues: {
                    firstName: user.firstName ? user.firstName : '',
                    lastName: user.lastName ? user.lastName : '',
                    email: user.email ? user.email : '',
                    password: '',
                    passwordConfirmation: ''
                }, validationSchema: validationSchema, validateOnBlur: true, onSubmit: handleSubmit },
                react_1.default.createElement(formik_1.Form, { autoComplete: 'off' },
                    react_1.default.createElement(react_material_ui_formik_1.FormikGrid, null,
                        react_1.default.createElement(react_material_ui_formik_1.FormikTextField, { type: 'text', name: 'firstName', label: 'First Name' }),
                        react_1.default.createElement(react_material_ui_formik_1.FormikTextField, { type: 'text', name: 'lastName', label: 'Last Name' }),
                        react_1.default.createElement(react_material_ui_formik_1.FormikTextField, { type: 'email', name: 'email', label: 'Email' }),
                        react_1.default.createElement(react_material_ui_formik_1.FormikTextField, { type: 'password', name: 'password', label: 'Enter New Password' }),
                        react_1.default.createElement(react_material_ui_formik_1.FormikTextField, { type: 'password', name: 'passwordConfirmation', label: 'Confirm New Password' })),
                    react_1.default.createElement(react_material_ui_formik_1.FormikButton, null, "Save Profile")))))),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'error', open: Boolean(error) }, "Failed to update account. Please try again later."),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'success', open: onSuccess }, "Profile updated.")));
};
exports.UserProfile = UserProfile;
//# sourceMappingURL=UserProfile.js.map